
import Component from "vue-class-component"
import { Prop, Watch } from "vue-property-decorator"
import { mixins } from "vue-class-component"
import Calculator from "@/components/mixins/Calculator.vue"
import { PreislisteProdukt } from "@/entities/common/pliste_produkt_zeit"
import ProdukteLogic from "@/logic/produkte_logic"
import FilialeHeader from "./FilialeHeader.vue"
import Artikel from "./Artikel.vue"
import ErrorBox from "./ErrorBox.vue"
import ArtikelEdit from "./ArtikelEdit.vue"
import BstlArtikel from "@/entities/common/bstl_artikel"

@Component({ components: { FilialeHeader, Artikel, ArtikelEdit, ErrorBox } })
export default class Produkte extends mixins(Calculator) {
  @Prop() logic: ProdukteLogic
  @Prop() warenkorb: BstlArtikel[]
  @Prop() warenkorbGefuellt: boolean
  kategorieTab: string = null

  get artikel() {
    return this.logic.artikel
  }

  @Watch("logic.preisliste.kategorien", { immediate: true, deep: true })
  watchPreisliste(newValue) {
    if (newValue) {
      setTimeout(this.initJs, 1000)
    } else {
    }
  }

  scrollToAnchorPoint(refName) {
    const el = document.getElementById(refName)
    el.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    })
  }

  artikelWaehlen(artikel: PreislisteProdukt) {
    this.logic.artikelWaehlen(artikel)
  }

  bestellungEinfuegen() {
    this.logic.bestellungEinfuegen()
  }

  addArtikel(bstlArtikel: BstlArtikel) {
    this.logic.addArtikel(bstlArtikel)
  }

  closeDialog() {
    this.logic.artikelDialogVisible = false
  }

  moveToBlue(id) {
    const blue = document.getElementById(id)
    let position = blue.getBoundingClientRect()
    // scrolls to 20px above element
    console.log(position)
    window.scrollTo(position.left, position.top + window.scrollY - 80)
  }

  initJs() {
    const header = document.querySelector("[data-header]") as any
    const sections = [...document.querySelectorAll("[data-section]")]
    console.log("sections " + sections.length)
    const scrollRoot = document.querySelector("[data-scroller]")
    const headerLinks = [...document.querySelectorAll("[data-link]")]

    let prevYPosition = 0
    let direction = "up"

    const options = {
      root: scrollRoot,
      rootMargin: `${header.offsetHeight * -1}px`,
      threshold: 0,
    }

    const getTargetSection = (entry) => {
      const index = sections.findIndex((section) => section == entry.target)

      if (index >= sections.length - 1) {
        return entry.target
      } else {
        return sections[index + 1]
      }
    }

    const updateColors = (target) => {
      const theme = target.dataset.section
      header.setAttribute("data-theme", theme)
    }

    const shouldUpdate = (entry) => {
      if (direction === "down" && !entry.isIntersecting) {
        return true
      }

      if (direction === "up" && entry.isIntersecting) {
        return true
      }

      return false
    }

    const updateMarker = (target) => {
      const id = target.id
      this.kategorieTab = id
      console.log("kategorie tab: " + this.kategorieTab)

      if (!id) return

      // let link = headerLinks.find((el) => {
      //   return el.getAttribute("href") === `#${id}`;
      // });

      // link = link || headerLinks[0];

      // const distanceFromLeft = link.getBoundingClientRect().left;

      // header.style.setProperty("--markerWidth", `${link.clientWidth}px`);
      // header.style.setProperty("--markerLeft", `${distanceFromLeft}px`);
    }

    const onIntersect = (entries, observer) => {
      entries.forEach((entry) => {
        if (scrollRoot.scrollTop > prevYPosition) {
          direction = "down"
        } else {
          direction = "up"
        }

        prevYPosition = scrollRoot.scrollTop

        const target =
          direction === "down" ? getTargetSection(entry) : entry.target

        if (shouldUpdate(entry)) {
          updateColors(target)
          updateMarker(target)
        }
      })
    }

    document.addEventListener("readystatechange", (e) => {
      let d = e as any
      if (d.target.readyState === "complete") {
        updateMarker(sections[0])
      }
    })

    const observer = new IntersectionObserver(onIntersect, options)
    sections.forEach((section) => {
      observer.observe(section)
    })
  }
}
